'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SurveyDetailCtrl', SurveyDetailCtrl);

  SurveyDetailCtrl.$inject = ['$log', '$q', '$translate', '$stateParams', 'languageSvc', 'surveySvc', 'onboardingRouter', 'userSvc'];

  /* @ngInject */
  function SurveyDetailCtrl($log, $q, $translate, $stateParams, languageSvc, surveySvc, onboardingRouter, userSvc) {
    var vm = this;
    vm.title = 'SurveyDetailCtrl';
    vm.getTemplateUrl = getTemplateUrl;
    vm.setAnswers = setAnswers;
    vm.isAnswerSelected = isAnswerSelected;

    vm.$onInit = activate;

    ////////////////

    function activate() {
      $log.debug('SurveyDetailCtrl activated for program: ', vm.program);
      var translatePrefix = vm.context + '.survey.questions.' + vm.program;

      $q.all([userSvc.getUser(), surveySvc.getAllPrograms()]).then(function (results) {
        vm.user = results[0];
        var programs = results[1];
        $log.debug('programs: ', programs);
        var questions = [];
        _.each(programs, function (elem) {
          var q = {};
          var translateId = translatePrefix + '.questions.' + elem.shortName.toLowerCase();
          $translate.use(languageSvc.getLanguage()).then(function () {
            var label = $translate.instant(translateId);
            $log.debug('SurveyDetailCtrl - question translation : ', label);
            q.shortName = elem.shortName;
            q.label = label;
            q.show = translateId !== label;
            q.id = elem.id;
            questions.push(q);
          });
        });
        $log.debug('rendered questions: ', questions);
        vm.questions = questions;
      });
    }

    function getTemplateUrl() {
      var _url;
      switch (vm.context) {
        case 'iframe':
          _url = 'onboarding/templates/survey/surveydetail-iframe.html';
          break;
        case 'onboarding':
          _url = 'onboarding/templates/survey/surveydetail-onboarding.html';
          break;
        default:
          _url = 'onboarding/templates/survey/surveydetail-profile.html';
          break;
      }
      return _url;
    }

    function setAnswers(answers) {
      var req = [];
      // Each submitted program
      _.each(_.keys(answers), function (key) {
        // Check if item is selected
        if (answers[key]) {
          // Find associated question
          var obj = _.find(vm.questions, function (q) {
            //if is SMI then depression
            if (_.includes(key, 'smi')) {
              return 'condition:depression' === q.shortName;
            } else {
              return key === q.shortName;
            }
          });
          // If found, build program and add to req list
          if (obj) {
            var a = {},
                dup = _.filter(req, function (i) {
              return i.id === obj.id;
            });
            if (!dup || dup.length === 0) {
              a.shortName = obj.shortName;
              a.id = obj.id;

              req.push(a);
            }
          }
        }
      });
      surveySvc.setWellnessProgram(req).then(function () {
        vm.success = true;
        if (vm.context !== 'profile') {
          onboardingRouter.goToNextStep($stateParams, {
            name: vm.context + '.survey.overlay'
          });
        }
      });
    }

    function isAnswerSelected(model) {
      return _.some(_.keys(model), function (key) {
        return model[key];
      });
    }
  }
})();